import React from 'react';
import { InfoCardWidget } from '../../../../statisticsWidgets/statisticsWidgets';

export default ({ data, title, loading, children, comment }) => {
  return (
    <InfoCardWidget primaryColor="#1b7ecf" secondaryColor="#595959" icon="icon-pray" title={title}
                    data={data} loading={loading} comment={comment}>
      {children}
    </InfoCardWidget>
  );
};



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/widgets/praying.js